import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from './Api';
import logoImg from '../assets/images/nav-logo.png';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        try {
            const response = await API.post('reset-password-confirm/', {
                email: email
            });
            if (response.status === 200) {
                setMessage("A password reset link has been sent to your email.");
            }
        } catch (err) {
            setError("Email ID not found or technical issue.");
        }
    };

    return (
        <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-black/80 backdrop-blur-md p-4">

            <div className="relative w-full max-w-md overflow-hidden rounded-3xl bg-white shadow-[0_25px_80px_rgba(0,0,0,0.35)]">

                {/* Close Button */}
                <button
                    onClick={() => navigate('/TGSH/login')}
                    className="absolute top-4 right-5 text-3xl text-gray-400 hover:text-red-500 transition"
                >
                    &times;
                </button>

                {/* Header */}
                <div className="bg-gradient-to-r from-[#032167] to-[#54a50f] px-8 py-8 text-center">

                    <img
                        src={logoImg}
                        alt="Logo"
                        className="h-20 mx-auto mb-4 bg-white rounded-full p-2 shadow-lg"
                    />

                    <h2 className="text-3xl font-bold text-white">
                        Forgot Password
                    </h2>

                    <p className="text-white/80 text-sm mt-2">
                        Reset your account password securely
                    </p>

                </div>

                {/* Form */}
                <div className="p-6 md:p-8">

                    <form
                        onSubmit={handleSubmit}
                        className="space-y-5"
                    >

                        <div>

                            <label className="block text-sm font-semibold text-gray-700 mb-2">
                                Registered Email Address
                            </label>

                            <input
                                type="email"
                                value={email}
                                onChange={(e) =>
                                    setEmail(e.target.value)
                                }
                                placeholder="Enter your email address"
                                required
                                className="
                                    w-full
                                    rounded-xl
                                    border
                                    border-gray-300
                                    px-4
                                    py-3
                                    outline-none
                                    transition
                                    focus:border-[#54a50f]
                                    focus:ring-4
                                    focus:ring-green-100
                                "
                            />

                        </div>

                        {message && (
                            <div className="rounded-xl border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-700">
                                {message}
                            </div>
                        )}

                        {error && (
                            <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            className="
                                w-full
                                rounded-xl
                                bg-[#54a50f]
                                py-3
                                font-bold
                                text-white
                                uppercase
                                tracking-wider
                                shadow-lg
                                transition
                                hover:bg-[#032167]
                                hover:scale-[1.02]
                            "
                        >
                            Send Reset Link
                        </button>

                    </form>

                    <div className="mt-6 text-center">

                        <button
                            onClick={() => navigate('/TGSH/login')}
                            className="
                                text-sm
                                font-medium
                                text-[#032167]
                                hover:text-[#54a50f]
                                transition
                            "
                        >
                            ← Back To Login
                        </button>

                    </div>

                </div>

            </div>

        </div>
    );
};

export default ForgotPassword;